import React from 'react';

/**
 * Hidden draggable element at the bottom of the page for drag-and-drop functionality.
 */
function PageBottomHiddenDraggable(props) {
    return (
        <React.Fragment>
            <div id="bottom-hidden-enter" className="bottom-hidden hidden draggable" onDragEnter={props.onDragEnter} />
            <div id="bottom-hidden-exit" className="bottom-hidden hidden draggable" onDragEnter={props.onDragEnter} />
        </React.Fragment>
    );
}

export default PageBottomHiddenDraggable;

